import { BaseDataService } from "../../../services/base/BaseDataService";
import { hasEmbeddedDataImage, withUploadRejectionDetection } from '../../../helpers/uploadRequestRejection';
import { PDFNoteCommentQuery } from "../models/PDFNoteCommentQuery";
import { PDFNoteComment } from "../models/PDFNoteComment";

export class PDFNoteCommentService extends BaseDataService<PDFNoteComment, PDFNoteCommentQuery> {
  protected prefixUrl: string = `PDFNoteComments`;

  save(data: PDFNoteComment[]) {
    if (data.some(comment => hasEmbeddedDataImage(comment.Title))) {
      return this.api.post<PDFNoteComment[]>(`${this.prefixUrl}/save`, data, withUploadRejectionDetection());
    }
    return super.save(data);
  }
}
